export const contentgridUrl = 'https://contentgrid.homedepot-static.com';
